import React, { useState } from 'react';
import { Button } from '../../Component/Button/Button';
import { FiAlertTriangle, FiCalendar } from 'react-icons/fi';
import classes from './AssignDataRoomWithCalendarModal.module.css';
import { Modal } from 'react-bootstrap';

const AssignDataRoomWithCalendarModal = ({ show, setShow, subTitle, onClick, isApiCall }) => {
  const [selectedDate, setSelectedDate] = useState('');

  const getTomorrowDate = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow.toISOString().split('T')[0];
  };

  const handleConfirm = () => {
    if (selectedDate) {
      onClick(selectedDate);
    }
  };

  const handleClose = () => {
    setSelectedDate('');
    setShow(false);
  };

  return (
    <>
      <style jsx>{`
        .modal-content {
          width: 100%;
          border-radius: 20px;
          overflow: hidden;
        }
        .modal-body {
          padding: 24px;
        }
        .modal-header {
          flex-direction: column;
          background: var(--dashboard-main-color);
          border-bottom: none;
          padding: 0.75rem;
        }
        .name {
          font-size: 18px;
          color: var(--text-color-black);
        }
      `}</style>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header>
          <div className={[classes.iconDiv].join(' ')}>
            <FiAlertTriangle size={'60px'} color={'var(--white-color)'} />
          </div>
          <h4 className={[classes.headingText].join(' ')}>Are You Sure</h4>
        </Modal.Header>
        <Modal.Body>
          <div className={classes.content}>
            <div className={classes.mainDiv}>
              <p className={[classes.message].join(' ')}>{subTitle}</p>
              
              {/* Calendar Input */}
              <div className={classes.calendarWrapper}>
                <label className={classes.calendarLabel}>
                  <FiCalendar className={classes.calendarIcon} />
                  Select Date
                </label>
                <input
                  type="date"
                  className={classes.dateInput}
                  value={selectedDate}
                  onChange={(e) => setSelectedDate(e.target.value)}
                  min={getTomorrowDate()}
                  required
                />
              </div>
            </div>
            <div className={classes.btnsBox}>
              <Button
                className={classes.yesBtn}
                onClick={handleConfirm}
                disabled={isApiCall || !selectedDate}
              >
                {isApiCall ? 'Wait' : 'Yes'}
              </Button>
              <Button
                className={classes.noBtn}
                onClick={handleClose}
                disabled={isApiCall}
              >
                No
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AssignDataRoomWithCalendarModal;